import React, { Fragment, useMemo } from 'react';
import { If } from 'common/src/components';
import { ElementIconType, ICustomAdvancedTableColumnTitle, IFooterBtnInfo, ITitleIcon } from '../../interface';
import { Button, Iconfont, Tooltip } from '@umu/umu-design';
import './index.scss';
import { getContentElement } from '../../dataFlow/element';
import { Checkbox } from '@umu/design-base';

const getTitleIcon = (data?: ITitleIcon) => {
    if (!data) {
        return null;
    }
    return (
        <Fragment>
            {data?.type === ElementIconType.ICON && (
                <Iconfont
                    type={data?.iconType || ''}
                    className={`${data.className} custom-advanced-table-column-title-icon`}
                />
            )}
            {data?.type === ElementIconType.CLS && (
                <i className={`${data.className} custom-advanced-table-column-title-icon`}></i>
            )}
        </Fragment>
    );
};

const CustomColumnTitle = (props: ICustomAdvancedTableColumnTitle) => {
    const {
        title,
        titlePrefix,
        titleIcon,
        checkbox = false,
        titleSuffix,
        suffixTitleIcon,
        tooltipConfig,
        className,
        expandInfo,
        ...rest
    } = props;
    const { checkInfo } = expandInfo || {};
    const onRenderContent = () => {
        const isOnlyTitle = !titlePrefix && !titleIcon && !titleSuffix && !suffixTitleIcon;
        if (isOnlyTitle) {
            return title;
        }
        const titleIconElement = getTitleIcon(titleIcon);
        const suffixTitleIconElement = getTitleIcon(suffixTitleIcon);
        return (
            <div className={`custom-advanced-table-column-title ${className}`} {...rest}>
                <If condition={!!titlePrefix}>
                    <div className="custom-advanced-table-column-title-prefix">{titlePrefix}</div>
                </If>
                {titleIconElement}
                <div className="custom-advanced-table-column-title-main">{title}</div>
                {suffixTitleIconElement}
                <If condition={!!titleSuffix}>
                    <div className="custom-advanced-table-column-title-suffix">{titleSuffix}</div>
                </If>
            </div>
        );
    };

    const isShowTooltip = useMemo(() => {
        return tooltipConfig && !!tooltipConfig.isShow;
    }, [tooltipConfig]);
    const getToolTipInfo = () => {
        if (!isShowTooltip) {
            return '';
        }
        const {
            showTitle = false,
            content: tooltipContent = '',
            titleContent = '',
            footerContent = { btnList: [] },
        } = tooltipConfig || {};
        return (
            <div>
                <If condition={!!showTitle}>
                    <Fragment>{onRenderContent()}</Fragment>
                </If>
                {getContentElement(titleContent, {})}
                {getContentElement(tooltipContent, {})}
                <If condition={(footerContent?.btnList).length > 0}>
                    <div className="custom-advanced-table-column-title-tooltip-footer">
                        {footerContent.btnList.map((item: IFooterBtnInfo, index: number) => {
                            const { label = '', ...rest } = item;
                            return (
                                <Button key={index} {...rest}>
                                    {label}
                                </Button>
                            );
                        })}
                    </div>
                </If>
            </div>
        );
    };
    return (
        <Tooltip placement="bottom" title={getToolTipInfo()} {...tooltipConfig?.config}>
            <div className="column-title">
                <If condition={checkbox}>
                    <Checkbox
                        checked={checkInfo?.allSelected}
                        onClick={checkInfo?.toggleAll}
                        indeterminate={checkInfo?.partiallySelected}
                        className="column-title-checkbox"
                    />
                </If>
                {onRenderContent()}
            </div>
        </Tooltip>
    );
};
export { CustomColumnTitle };
